// Rightward chevron: collapsed group headers, and the trailing affordance on a "Review" button.
// Decorative — the control it sits in carries the accessible name, so the glyph
// is aria-hidden. Size via CSS font-size (renders at 1em); color via currentColor.
export function ChevronRightIcon({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...(className ? { className } : {})}
    >
      <polyline points="9 6 15 12 9 18" />
    </svg>
  );
}
